module.exports = __webpack_public_path__ + "static/img/shz.2c9be9b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shz.svg
// module id = KctQ
// module chunks = 1 2